import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { SearchIcon as Component } from './search-icon';
import type { IDeps, TSearchIcon } from './models';
import styles from './styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const SearchIcon = createWidget<IDeps, TSearchIcon>({
    styles,
})(Component);
